import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";
import Tabs, { Tab } from "material-ui/Tabs";
import { withStyles } from "material-ui/styles";
import { Link } from "react-router-dom";
import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  Label,
  Cell
} from "recharts";
import styles from "./styles";
import { infoData } from "./infoenum";
import { CUSTOM_TEST_STANDARD } from "../../../../../common/constants";

class MaxthroughputResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabPosition: 0
    };
  }

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    this.setState({ tabPosition: value });
  };
  handleTickClick = (data, index, e) => {
    let { tabPosition } = this.state;
    this.setState({ tabPosition: index });
  };

  formatNumber = number => {
    if (
      (number.toString().split(".")[0] &&
        number.toString().split(".")[0].length > 9) ||
      (number.toString().split(".")[1] &&
        number.toString().split(".")[1].length > 6)
    ) {
      return number.toExponential(3).toUpperCase();
    } else return number;
  };
  generateTicks = linkspeed => {
    let diff = linkspeed / 5;
    let tickArray = [];
    for (var i = 0; i <= 5; i++) {
      tickArray.push((diff * i).toFixed(1));
    }
    return tickArray;
  };

  render() {
    const {
      classes,
      result,
      subtest,
      subtestMaxthroughputResults,
      translate,
      chartMeasurementUnit
    } = this.props;
    let { tabPosition } = this.state;
    let graphData = [];
    let graphData2 = [];

    subtestMaxthroughputResults && subtestMaxthroughputResults.framedetails
      ? subtestMaxthroughputResults.framedetails.forEach(function(item) {
          graphData.push({
            name: item.framesize,
            value: item.framesize,
            linkspeed: subtestMaxthroughputResults.linkspeed,
            filledgradient:
              (item.filledgradient / 100) *
              subtestMaxthroughputResults.linkspeed,
            emptygradient:
              subtestMaxthroughputResults.linkspeed -
              (item.filledgradient / 100) *
                subtestMaxthroughputResults.linkspeed,
            status: item.status
          });
        })
      : null;
    // graphData.push(
    //   {
    //     name: 64,
    //     value: 64,
    //     linkspeed: 10,
    //     filledgradient: (50 / 100) * 10,
    //     emptygradient: 5,
    //     status: "PASSED"
    //   },
    //   {
    //     name: 256,
    //     value: 256,
    //     linkspeed: 10,
    //     filledgradient: 6,
    //     emptygradient: 4,
    //     status: "FAILED"
    //   },
    //   {
    //     name: 512,
    //     value: 512,
    //     linkspeed: 10,
    //     filledgradient: 4,
    //     emptygradient: 6,
    //     status: "PASSED"
    //   },
    //   {
    //     name: 1518,
    //     value: 1518,
    //     linkspeed: 10,
    //     filledgradient: 8,
    //     emptygradient: 2,
    //     status: "PASSED"
    //   }
    // );
    return subtestMaxthroughputResults &&
      subtestMaxthroughputResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={2}></Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestMaxthroughputResults.teststarted
                  ? moment(subtestMaxthroughputResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_duration")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestMaxthroughputResults.testduration}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_link_speed")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestMaxthroughputResults.linkspeed + " Gb/s"}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "7px" }}
                color="inherit"
              >
                {translate("result_info_status")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestMaxthroughputResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText}>
                      {infoData.find(
                        o =>
                          o.name === subtestMaxthroughputResults.subteststatus
                      )
                        ? " " +
                          translate(
                            infoData.find(
                              o =>
                                o.name ===
                                subtestMaxthroughputResults.subteststatus
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>

          <div className={classes.div_table1}>
            {subtestMaxthroughputResults && (
              <Grid container>
                <Grid item xs={6}>
                  <Table className={classes.table}>
                    <colgroup>
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableheader_first}>
                          {translate("uptime_frame_size")}
                        </TableCell>
                        <TableCell
                          className={classes.tableheader_status}
                        ></TableCell>
                        <TableCell className={classes.tableheader_tb}>
                          {translate("result_total_bandwidth")}
                          <Typography className={classes.tableheader_tb2}>
                            (Gb/s)
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.tableheader_last}>
                          {translate("result_errors")}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {subtestMaxthroughputResults &&
                      subtestMaxthroughputResults.framedetails &&
                      subtestMaxthroughputResults.framedetails.length
                        ? subtestMaxthroughputResults.framedetails.map(
                            (item, k) => {
                              return (
                                <TableRow key={item.id}>
                                  <TableCell>
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        this.handleTabChange(null, k)
                                      }
                                    >
                                      <Typography className={classes.tab_link}>
                                        {item.framesize}
                                      </Typography>
                                    </Link>
                                  </TableCell>
                                  <TableCell
                                    className={classes.tablecontent_status}
                                  >
                                    {item.status.toLowerCase() == "passed" ? (
                                      <Icon className={classes.passState}>
                                        check_circle
                                      </Icon>
                                    ) : (
                                      <Icon className={classes.failState}>
                                        cancel
                                      </Icon>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tablecontent_tb}
                                  >
                                    {item.totalbandwidth.toFixed(4)}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tablecontent_last}
                                  >
                                    {item.errorcount != null
                                      ? this.formatNumber(item.errorcount)
                                      : ""}
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )
                        : null}
                    </TableBody>
                  </Table>
                  <div
                    className={classes.tablecontent_first}
                    style={{ marginTop: "7px" }}
                  >{`${translate("result_standard")} : ${
                    subtestMaxthroughputResults.teststandard
                      ? subtestMaxthroughputResults.teststandard
                          .trim()
                          .toLowerCase()
                          .substring(0, 6) == CUSTOM_TEST_STANDARD
                        ? translate("test_standard_custom") +
                          " " +
                          subtestMaxthroughputResults.teststandard.substring(6)
                        : subtestMaxthroughputResults.teststandard
                      : ""
                  } ${
                    subtestMaxthroughputResults.interfacetype
                      ? translate(
                          subtestMaxthroughputResults.interfacetype.toLowerCase()
                        )
                      : ""
                  }`}</div>
                  <div className={classes.tablecontent_first}>
                    {translate("indicates_quick_test")}
                  </div>
                  <div className={classes.bargraph}>
                    <BarChart
                      width={550}
                      height={300}
                      data={graphData}
                      layout="vertical"
                      margin={{
                        right: 20
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        type="number"
                        dataKey="linkspeed"
                        domain={[0, "dataMax"]}
                        //interval={2}
                        height={60}
                        ticks={this.generateTicks(
                          subtestMaxthroughputResults.linkspeed
                        )}
                      >
                        <Label
                          //angle={270}
                          position="center"
                          style={{ textAnchor: "middle" }}
                          dy={10}
                        >
                          {translate("uptime_linkspeed")}
                        </Label>
                      </XAxis>

                      <YAxis
                        type="category"
                        onClick={this.handleTickClick}
                        dataKey="value"
                        cursor="pointer"
                        tick={{ fill: "#005795" }}
                      >
                        <Label
                          angle={270}
                          position="left"
                          style={{ textAnchor: "middle" }}
                          dx={10}
                        >
                          {translate("uptime_frame_size")}
                        </Label>
                      </YAxis>
                      {/* <Tooltip /> */}
                      {/* <Legend /> */}
                      <Bar
                        dataKey="filledgradient"
                        fill="#4caf50"
                        barSize={35}
                        stackId="a"
                      >
                        {graphData.map((entry, index) => (
                          <Cell
                            fill={
                              entry.status === "PASSED" ? "#4caf50" : "#FF5252"
                            }
                            stroke="#000000"
                            strokeWidth={0.3}
                          />
                        ))}
                      </Bar>
                      <Bar
                        dataKey="emptygradient"
                        fill="#FFFFFF"
                        barSize={35}
                        stackId="a"
                      >
                        {graphData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            stroke="#000000"
                            strokeWidth={0.3}
                          />
                        ))}
                      </Bar>
                    </BarChart>
                  </div>
                </Grid>
                <Grid item xs={6} style={{ borderLeft: "1px solid #ccc" }}>
                  <Tabs value={tabPosition} onChange={this.handleTabChange}>
                    {subtestMaxthroughputResults.framedetails.map(
                      (tab, index) => {
                        return (
                          <Tab
                            key={index}
                            icon={
                              tab.status.toLowerCase() == "passed" ? (
                                <Icon className={classes.passState}>
                                  check_circle
                                </Icon>
                              ) : (
                                <Icon className={classes.failState}>
                                  cancel
                                </Icon>
                              )
                            }
                            fontSize="10pt !important"
                            label={
                              <Typography className={classes.tableheader_tb}>
                                {tab.framesize}
                              </Typography>
                            }
                            className={classes.tab}
                          />
                        );
                      }
                    )}
                  </Tabs>
                  {subtestMaxthroughputResults &&
                    subtestMaxthroughputResults.framedetails &&
                    subtestMaxthroughputResults.framedetails.length && (
                      <Table className={classes.table}>
                        <TableBody>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("uptime_linkspeed2") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.linkspeed + " Gb/s"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("uptime_frame_size") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].framesize + " bytes"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_total_bandwidth2") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].totalbandwidth.toFixed(4) + " Gb/s"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_usable_bandwidth") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].usablebandwidth.toFixed(4) + " Gb/s"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("uptime_nw_overhead2") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].networkoverhead.toFixed(4) + " Gb/s"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_line_utilization") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].lineutilization.toFixed(3) + "%"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_test_duration2") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {
                                subtestMaxthroughputResults.framedetails[
                                  tabPosition
                                ].duration
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_tx2") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].txcount != null
                                ? this.formatNumber(
                                    subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].txcount
                                  )
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_rx2") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].rxcount != null
                                ? this.formatNumber(
                                    subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].rxcount
                                  )
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_error_count") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].errorcount != null
                                ? this.formatNumber(
                                    subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].errorcount
                                  )
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("result_error_ratio") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              {subtestMaxthroughputResults.framedetails[
                                tabPosition
                              ].errorratio != null
                                ? this.formatNumber(
                                    subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].errorratio
                                  )
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              <Typography
                                className={classes.delayText}
                                color="inherit"
                              >
                                {translate("result_propagation_delay") + ":"}
                              </Typography>
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              <table>
                                <tr
                                  style={{
                                    background: "#f2f2f2"
                                  }}
                                >
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "15px 35px 15px 35px"
                                    }}
                                  >
                                    {translate("result_min")}
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "15px 35px 15px 35px"
                                    }}
                                  >
                                    {translate("result_avg")}
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "15px 35px 15px 35px"
                                    }}
                                  >
                                    {translate("result_max")}
                                  </th>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      color: "white",
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                      backgroundColor:
                                        subtestMaxthroughputResults
                                          .framedetails[tabPosition]
                                          .propogationmin >
                                        subtestMaxthroughputResults.propagationdelaylimit *
                                          1000
                                          ? "#FF0000"
                                          : "#000000"
                                    }}
                                  >
                                    {subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].propogationmin.toFixed(3)}
                                  </td>
                                  <td
                                    style={{
                                      color: "white",
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                      backgroundColor:
                                        subtestMaxthroughputResults
                                          .framedetails[tabPosition]
                                          .propogationavg >
                                        subtestMaxthroughputResults.propagationdelaylimit *
                                          1000
                                          ? "#FF0000"
                                          : "#000000"
                                    }}
                                  >
                                    {subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].propogationavg.toFixed(3)}
                                  </td>
                                  <td
                                    style={{
                                      color: "white",
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                      backgroundColor:
                                        subtestMaxthroughputResults
                                          .framedetails[tabPosition]
                                          .propogationmax >
                                        subtestMaxthroughputResults.propagationdelaylimit *
                                          1000
                                          ? "#FF0000"
                                          : "#000000"
                                    }}
                                  >
                                    {subtestMaxthroughputResults.framedetails[
                                      tabPosition
                                    ].propogationmax.toFixed(3)}
                                  </td>
                                </tr>
                              </table>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tablecontent_first}>
                              {translate("jitter") + ":"}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first}>
                              <table>
                                <tr
                                  style={{
                                    background: "#f2f2f2"
                                  }}
                                >
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "15px 35px 15px 35px"
                                    }}
                                  >
                                    {translate("result_min")}
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "15px 35px 15px 35px"
                                    }}
                                  >
                                    {translate("result_avg")}
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "15px 35px 15px 35px"
                                    }}
                                  >
                                    {translate("result_max")}
                                  </th>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      color: "white",
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                      backgroundColor:
                                        subtestMaxthroughputResults
                                          .framedetails[tabPosition].jittermin >
                                        subtestMaxthroughputResults.jitterlimit *
                                          1000000
                                          ? "#FF0000"
                                          : "#000000"
                                    }}
                                  >
                                    {
                                      subtestMaxthroughputResults.framedetails[
                                        tabPosition
                                      ].jittermin
                                    }
                                  </td>
                                  <td
                                    style={{
                                      color: "white",
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                      backgroundColor:
                                        subtestMaxthroughputResults
                                          .framedetails[tabPosition].jitteravg >
                                        subtestMaxthroughputResults.jitterlimit *
                                          1000000
                                          ? "#FF0000"
                                          : "#000000"
                                    }}
                                  >
                                    {
                                      subtestMaxthroughputResults.framedetails[
                                        tabPosition
                                      ].jitteravg
                                    }
                                  </td>
                                  <td
                                    style={{
                                      color: "white",
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                      backgroundColor:
                                        subtestMaxthroughputResults
                                          .framedetails[tabPosition].jittermax >
                                        subtestMaxthroughputResults.jitterlimit *
                                          1000000
                                          ? "#FF0000"
                                          : "#000000"
                                    }}
                                  >
                                    {
                                      subtestMaxthroughputResults.framedetails[
                                        tabPosition
                                      ].jittermax
                                    }
                                  </td>
                                </tr>
                              </table>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    )}
                </Grid>
              </Grid>
            )}
          </div>
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getsubtestMaxthroughputResults, subtest, pager } = this.props;

    getsubtestMaxthroughputResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getsubtestMaxthroughputResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getsubtestMaxthroughputResults(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(MaxthroughputResult);



// WEBPACK FOOTER //
// ./src/components/common/results/views/maxthroughput/index.js